/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class CloseContextMenuService {

    private dropdownMap: Map<string, NgbDropdown> = new Map<string, NgbDropdown>();

    open(id: string, dropdown: NgbDropdown): void {
        this.closeAll();
        this.dropdownMap.set(id, dropdown);
        dropdown.open();
    }

    close(id: string, dropdown: NgbDropdown): void {
        dropdown.close();
        this.dropdownMap.delete(id);
    }

    closeAll(): void {
        this.dropdownMap.forEach((dropdown, id) => {
            this.close(id, dropdown);
        });
    }
}
